// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"32b839eb","350":"a5b38ee6","351":"7197295a","453":"d250f02d","756":"87dd3de6","866":"0457b006"}[chunkId] + ".chunk.js";
};